<template>
  <v-card :class="{ 'ma-6': !xs }">
    <v-card-title class="titles">
      {{ $t('thirdPartyTable.titleThirdParty') }}
    </v-card-title>
    <v-container fluid>
      <v-row no-gutters>
        <v-col v-for="(service, index) in services" :key="index" cols="auto">
          <ServiceComponent
            class="service-component"
            data-cy="serviceComponent"
            :serviceKey="service.key"
            :title="service.title"
            :serviceUrl="service.url"
          ></ServiceComponent>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useDisplay } from 'vuetify'
import { ServiceKey } from '@/store/adminpanel'
import ServiceComponent from './serviceComponent.vue'

interface ServiceEntry {
  key: ServiceKey
  title: string
  url: string
}

export default defineComponent({
  name: 'ThirdPartyTable',
  setup() {
    const { xs } = useDisplay()
    return { xs }
  },
  data() {
    return {
      services: [
        { key: ServiceKey.AUTH0, title: 'Auth0', url: 'https://status.auth0.com/' },
        { key: ServiceKey.SENDGRID, title: 'SendGrid', url: 'https://status.sendgrid.com/' },
        { key: ServiceKey.TWILIO, title: 'Twilio', url: 'https://status.twilio.com/' },
        { key: ServiceKey.FLEXERA, title: 'Flexera', url: 'https://status.flexera.com/' },
        { key: ServiceKey.MONGODB, title: 'MongoDB', url: 'https://status.mongodb.com/' },
        { key: ServiceKey.CLEARBLADE, title: 'ClearBlade', url: 'https://status.clearblade.com/' },
        { key: ServiceKey.APIGEE, title: 'Apigee', url: 'https://status.apigee.com/' },
        {
          key: ServiceKey.GOOGLEMAPS,
          title: 'Google Maps',
          url: 'https://status.cloud.google.com/maps-platform/'
        },
        { key: ServiceKey.GODADDY, title: 'GoDaddy', url: 'https://status.godaddy.com/' }
      ] as ServiceEntry[]
    }
  },
  components: {
    ServiceComponent
  }
})
</script>

<style lang="scss" scoped>
.v-row {
  padding: 20px;
}
.titles {
  font-weight: 300;
  padding: 16px;
  margin-bottom: -25px;
}
</style>
